import { escapeHtml } from './escape-html.util';
import { stripHtml } from './strip-html.utils';

const HIGHLIGHT_TAG = /(<\/?b>)/;

/**
 * Turns a search highlight fragment into HTML that is safe for `v-html`. The search engine
 * wraps matched terms in `<b>` but returns the stored text around them unescaped, and that
 * text is written by candidates, so everything except the `<b>` markers is escaped.
 */
export function toSafeHighlightHtml(fragment: string): string {
  return fragment
    .split(HIGHLIGHT_TAG)
    .map((part) => (part === '<b>' || part === '</b>' ? part : escapeHtml(part)))
    .join('');
}

/**
 * Renders stored text as plain text for a `v-html` sink. `stripHtml` alone is not enough:
 * it returns decoded text, so a stored `&lt;img onerror=…&gt;` would come back as live markup.
 */
export function toSafePlainHtml(value: string): string {
  return escapeHtml(stripHtml(value));
}
